<template>
    <div class="ui-content dashboard">
        <v-card class="mx-auto normal-card autohg">
            <div class="user-data">
                <v-row>
                    <v-col cols="12" sm="12">
                        <div class="show-drop-down">
                            <!-- <div class="label-data">
                                Select Center
                            </div>-->
                            <div class="field-data">
                                <multi-select
                                    allText="All Centers"
                                    :items="centers"
                                    label="Select Center"
                                    :onChange="onCneterchange"
                                    class="fix-200"
                                ></multi-select>
                            </div>
                        </div>
                        <div class="show-drop-down">
                            <!-- <div class="label-data">
                                Select Batch
                            </div>-->
                            <div class="field-data">
                                <multi-select
                                    allText="All Batches"
                                    :items="batches"
                                    label="Select Batch"
                                    :onChange="onBatchSelect"
                                    class="fix-200"
                                ></multi-select>

                                <!-- <v-select :items="itemsdrop" hide-details dense class="fix-200" filled></v-select> -->
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="(item, idx) in items" :key="idx">
                                <td>{{ item.name }}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.username }}</td>
                                <td class="check-100">
                                    <div class="check-cust">
                                        <v-checkbox v-model="item.checked"></v-checkbox>
                                    </div>
                                </td>
                                <!-- <td>{{ item.class_name }}</td>
                                <td>{{ item.batch_name }}</td>-->
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left">
                <v-btn
                    @click="openPopUp"
                    class="right-btn cust-btn"
                    color="primary"
                >Allocate New Batch</v-btn>
            </div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
        <AlertBox
            width="400px"
            :onClose="onClose"
            component="components/coordinator/users/BatchAllocation/BatchAllocationPopup"
            :status="status"
            :data="{centers,selectedUsers}"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "UsersParents",
    props: ['updateRouteDetails'],
    data() {
        return {
            batches: [],
            centers: [],
            selectedCenterId: null,
            selectedBatch: null,
            loading: false,
            status: false,
            orderBy: {
                field: "name",
                order: "ASC"
            },
            items: [],
            selctedUserForEdit: null,
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            status: false,
            selectedUsers: [],
            isLoadingFirstTime: true
        };
    },
    methods: {
        ...mapActions({
            getCenters: "centerAndBatchStore/getCenters",
            getBatches: "centerAndBatchStore/getBatches",
            getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
            approveOrDisapproveUser: "userStore/approveOrDisapproveUser"
        }),
        openPopUp() {
            if (this.items && this.items.length) {
                this.selectedUsers = this.items
                    .filter(i => i.checked)
                    .map(u => u.id);
                if (!this.selectedUsers || this.selectedUsers.length < 1) {
                    return this.$toasted.error(`Select atleast one user`);
                }

                this.status = true;
            }
        },
        onClose(data) {
            this.status = data.status;
            if (data.reload) {
                this.requesGetSelfSignedUpUsers();
            }
        },

        onCneterchange(centerIds) {
            this.selectedCenterId = centerIds;
        },
        resetPage() {
            this.currentPage = 1;
            this.updateCurrentPageInSession(1);
        },
        onCenterSelect(centerIds) {
            if (centerIds && centerIds.length) {
                if(!this.isLoadingFirstTime) this.resetPage();
                this.updateRouteDetails({type: 'centerIds', data: {centerIds}})
                this.$root.showLoader = true;
                this.getBatches({ center_id: centerIds })
                    .then(response => {
                        if (response && response.list && response.list.length) {
                            if (this.selectedBatch) {
                                let arr = [];
                                this.selectedBatch.map((xx, i) => {
                                    let isExist = false;
                                    response.list.map(x => {
                                        if (!isExist) {
                                            isExist = xx === x.id;
                                        }
                                    });
                                    if (!isExist) {
                                        arr.push(xx);
                                    }
                                });
                                if (arr && arr.length) {
                                    arr.map(xx => {
                                        this.selectedBatch.splice(
                                            this.selectedBatch.indexOf(xx),
                                            1
                                        );
                                    });
                                }
                            }

                            this.batches = response.list.map(x => {
                                let c = {};
                                c.text = x.name;
                                c.value = x.id;
                                c.checked =
                                    this.selectedBatch &&
                                    this.selectedBatch.indexOf(x.id) !== -1;
                                return c;
                            });
                        } else {
                            this.batches = [];
                        }
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            } else {
                this.batches = [];
            }
        },
        requestGetCenters() {
            this.$root.showLoader = true;
            this.getCenters()
                .then(response => {
                    this.centers = response.map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = this.selectedCenterId.includes(x.id);
                        return c;
                    });
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        requesGetSelfSignedUpUsers() {
            let reqData = {
                orderBy: this.orderBy,
                role_id: this.roleIds.ST,
                is_approved: 1,
                active: 1,
                pagination: { page: this.currentPage, pageSize: this.pageSize }
            };
            if (this.selectedBatch && this.selectedBatch.length > 0 && this.batches.length != this.selectedBatch.length) {
                reqData.batch_ids = this.selectedBatch;
            }
            if (this.selectedCenterId && this.selectedCenterId.length > 0 && this.centers.length != this.selectedCenterId.length) {
                reqData.center_ids = this.selectedCenterId;
            }
            this.$root.showLoader = true;
            this.getSelfSignedUpUsers(reqData)
                .then(response => {
                    this.isLoadedFirstTime = false;
                    if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    } 
                    this.items = response.list.map(u => {
                        u.checked = false;
                        return u;
                    });
                    this.totalPages = response.pagination.pageCount;
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
                if (e.data) {
                    this.items = this.items.map(u => {
                        u.checked = e.data.checked;
                        return u;
                    });
                }
            }
        },
        onSortChange() {
            this.requesGetSelfSignedUpUsers();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requesGetSelfSignedUpUsers();
        },
        onBatchSelect(selectedBatch) {
            this.selectedBatch = selectedBatch;
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.active = crd.tabDetails[crd.selectedTab].showActivated;
                this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
                this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
            }
            this.requestGetCenters();
            if(!crd && !crd.tabDetails[crd.selectedTab].centerIds) {
                this.requesGetSelfSignedUpUsers();
            }            
        },
    },
    mounted() {
        this.defaultData();
    },
    computed: {
        headers() {
            return [
                { text: "Name", value: "name" },
                { text: "Email ID", value: "email" },
                { text: "User ID", value: "username" },
                {
                    text: "All",
                    value: "check",
                    type: "check",
                    class: "check-100",
                    checked: this.isAllUserSelected
                }
                // { text: 'Class', value: 'class_name' },
                // { text: 'Batch', value: 'batch_name' },
            ];
        },
        isAllUserSelected() {
            if (this.items && this.items.length) {
                let tmpArry = this.items.filter(x => x.checked);
                if (tmpArry) {
                    return tmpArry.length === this.items.length;
                }
            }
            return false;
        }
    },
    watch: {
        selectedCenterId(val) {
            if (val) {
                this.onCenterSelect(val);
                this.requesGetSelfSignedUpUsers();
            }
        },
        selectedBatch(val) {
            if(!this.isLoadingFirstTime) this.resetPage();
            this.updateRouteDetails({type: 'batchIds', data: {batchIds: val}})
            this.requesGetSelfSignedUpUsers();
        }
    }
};
</script>